module.exports = __webpack_public_path__ + "img/US.49e3ac3c.svg";